import React from "react";
import { useNavigate } from "react-router-dom";

interface Appointment {
  id: string;
  patientName: string;
  time: string;
  contact: string;
  status: string;
}

interface Props {
  appointments: Appointment[];
}

const AppointmentsCard = ({ appointments }: Props) => {
  const navigate = useNavigate();

  return (
    <div style={{ fontSize: 12 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 12,
        }}
      >
        <div style={{ fontSize: 14, fontWeight: 600 }}>
          Appointments : {appointments.length}
        </div>

        {/* VIEW LINK */}
        <div
          style={{
            fontSize: 15,
            color: "#1976d2",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: 700,
          }}
          onClick={() => navigate("/layout/appointment")}
        >
          view
        </div>
      </div>

      {/* HEADER */}
      <div
        style={{
          display: "flex",
          fontWeight: 600,
          borderBottom: "1px solid #e2e8f0",
          paddingBottom: 6,
        }}
      >
        <div style={{ flex: 1.5 }}>Patient</div>
        <div style={{ flex: 0.8 }}>Time</div>
        <div style={{ flex: 1 }}>Contact</div>
        <div style={{ flex: 0.6 }}>Status</div>
      </div>

      {/* LIST */}
      <div style={{ maxHeight: 220, overflowY: "auto" }}>
        {appointments.length === 0 ? (
          <div style={{ padding: 12, color: "#777", fontStyle: "italic" }}>
            No appointments found
          </div>
        ) : (
          appointments.map((appt) => (
            <div
              key={appt.id}
              style={{
                display: "flex",
                padding: "10px 0",
                borderBottom: "1px solid #f1f5f9",
                cursor: "pointer",
              }}
            >
              <div style={{ flex: 1.5 }}>{appt.patientName}</div>
              <div style={{ flex: 0.8 }}>{appt.time}</div>
              <div style={{ flex: 1 }}>{appt.contact}</div>
              <div style={{ flex: 0.6, fontWeight: 600 }}>
                <span
                  style={{
                    color:
                      appt.status === "CONFIRMED"
                        ? "green"
                        : appt.status === "CANCELLED"
                        ? "red"
                        : "orange",
                  }}
                >
                  {appt.status}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AppointmentsCard;
